import { render } from "./ProjectsRoadmapChart.vue?vue&type=template&id=35003688&ts=true"
import script from "./ProjectsRoadmapChart.vue?vue&type=script&lang=ts"
export * from "./ProjectsRoadmapChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__